import * as React from 'react';
import { Typography } from '@mui/material';

import { CloseButton, Dialog, DialogContent, DialogTitle, Loading, ServiceItemList } from 'components';
import { ZoneServiceItemsForm } from 'forms';
import { useFetchZoneServiceItemsQuery } from 'store/apis';
import { useAppSelector } from 'store/store.hook';
import { selectCurrentUserInfo } from 'store/slices/auth.slice';

interface ZoneServiceItemsDialogProps {
  visible?: boolean;
  setVisible?: (visible: boolean) => void;
  zoneId: number;
}

export const ZoneServiceItemsDialog = ({
  visible = false,
  setVisible = () => {},
  zoneId,
}: ZoneServiceItemsDialogProps) => {
  const { orgSlug } = useAppSelector(selectCurrentUserInfo);
  const { data: serviceItems, isLoading, isFetching } = useFetchZoneServiceItemsQuery({ orgSlug, zoneId });
  const [fetchingCount, setFetchingCount] = React.useState<number>(0);

  const onClose = (event: any, reason: string) => {
    if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
      setVisible(false);
      document.body.removeAttribute('style');
    }
  };

  React.useEffect(() => {
    if (visible && isFetching) {
      setFetchingCount((prev) => prev + 1);
    }

    if (!visible) {
      setFetchingCount(0);
    }
  }, [visible, isFetching]);

  const loading = fetchingCount < 2 ? isFetching : isLoading;

  return (
    <Dialog onClose={onClose} open={visible}>
      <DialogTitle>
        <Typography variant="h5" component="span">
          Add service items to zone
        </Typography>
      </DialogTitle>

      <DialogContent>
        <ZoneServiceItemsForm zoneId={zoneId} />

        {loading ? (
          <Loading text="Loading zone service items..." height={120} />
        ) : (
          <ServiceItemList serviceItems={serviceItems} />
        )}
      </DialogContent>

      <CloseButton onClick={() => onClose(null, 'anyway')} />
    </Dialog>
  );
};
